<template>
  <ChartWrapper class="digital-rank-chart" :status="status">
    <div class="root">
      
      <div class="list-container" ref="listContainer">
        
        <div class="list-content" ref="listContent">
          
        <!-- <transition-group name="flip-list" tag="div" class="list" ref="list"> -->
          <div class="item-wrapper" ref="items" v-for="item in currentRanking" :key="item.id+'_'+currentTime">
            <!-- <div class="rank">{{item.rank}}</div> -->
            <div class="item" :class="{negative: item.sign<0,focussed: item.id===currentSector}" :style="{height: itemHeight+'px'}">
              <div class="label">{{t(item.id)}}</div>
              <div class="rows">
                <div class="bar-and-value">
                  <div class="bar" :style="{width:item.width+'%'}"></div>
                  <div class="value">
                    <span class="main-val">{{Math.round(item.value)+'%'}}</span>
                    <span v-if="item.comparedDatum" class="separator">/</span>
                    <span v-if="item.comparedDatum" class="compared-val">{{Math.round(item.comparedDatum.value)+'%'}}</span>
                  </div>
                </div>
                <div class="compared-bar" v-if="item.comparedDatum" :style="{width:item.comparedDatum.width+'%'}"></div>
                
              </div>
            </div>
          </div>
        <!-- </transition-group> -->
        </div>
        <div v-if="topItemIndex>0" class="scroll-btn scroll-btn-top" @click="scrollPrev"><div class="icon"/></div>
        <div v-if="topItemIndex<currentRanking.length-numItems" class="scroll-btn scroll-btn-bottom" @click="scrollNext"><div class="icon"/></div>
      </div>
      <div class="zero-line-wrapper">
        <div class="zero-line"></div>
      </div>
    </div>
    <div class="month-selector">
      <div
        class="month-button"
        v-for="month in timeOptions"
        :key="month.value"
        @click="$emit('changeTime',month)"
        :class="{selected: currentTime===month.value}"
      >{{month.label}}</div>
    </div>
  </ChartWrapper>
</template>


<script>
import d3 from '@/utils/d3_importer'
import moment from 'moment';
import ChartWrapper from '@/components/IndicatorCards/parts/charts/ChartWrapper'

const NUM_ITEMS = 8
export default {
  name: "DigitalRankStairs",
  props: ['status','data','compareData','sector','timeSelection'],
  components:{
    ChartWrapper
  },
  data (){
    return {
      // xScale: d3.scaleBand().padding(0.2),
      // yScale: d3.scaleLinear(),
      // xSubScale: d3.scaleBand().padding(0.2)
      itemHeight: 0,
      topItemIndex: -1,
      numItems: 0
    }
  },
  mounted () {
    this.$nextTick(()=>{
      d3.select(this.$refs.listContent).call( d3.drag()
        .on('start', ()=>{
          this.dragOffset = d3.event.y-this.$refs.listContent.style.top.replace('px','')
          this.$refs.listContent.style.transition = 'none'
          this.$refs.listContent.style.cursor = 'grabbing'
          this.dragMax = this.$refs.listContent.getBoundingClientRect().height - this.$refs.listContainer.getBoundingClientRect().height
        })
        .on('drag', ()=>{
          // console.log("d3.event",d3.event)
          let top = d3.event.y-this.dragOffset
          top = Math.min(0,Math.max(-this.dragMax,top))
          this.$refs.listContent.style.top = top +'px'
          
        })
        .on('end', ()=>{
          this.$refs.listContent.style.transition = null
          this.$refs.listContent.style.cursor = 'grab'
          let top = this.$refs.listContent.style.top.replace('px','')
          this.topItemIndex = -Math.floor(top/this.itemHeight)
        }))
          
      // this.numItems = NUM_ITEMS
      // this.itemHeight = window.innerHeight*0.03
      this.numItems = Math.floor(this.$refs.listContent.parentNode.clientHeight/(window.innerHeight*0.03))
      this.itemHeight = this.$refs.listContent && this.$refs.listContent.parentNode.clientHeight/this.numItems
      
      if(this.data) {
        // this.drawChart()
        this.$nextTick(()=>{
          this.scrollToTopItem()
        })
      }
    })
  },
  computed: {
    
    currentSector () {
      return this.sector || (this.currentRanking[0] && this.currentRanking[0].id)
    },
    currentTime () {
      return this.timeSelection || this.timeOptions[0].value
    },
    // topItemIndex: {
    //   get() {
    //     if(this._internalTopItemIndex>0){
    //       return this._internalTopItemIndex
    //     } else {
    //       let selIndex = this.currentRanking.findIndex((d)=>d.id===this.currentSector)
    //       let min = Math.min(this.currentRanking.length-this.numItems,Math.max(0,selIndex-(this.numItems/2-1)))
    //       return min
    //     }
    //   }, 
    //   set(value) {
    //     this._internalTopItemIndex = value
    //   }
    // },
    currentRanking () {
      if(!this.data) return []
      // if(!this.timeSelection) this.timeSelection = this.timeOptions[this.timeOptions.length-1].value
      let timeSelection = this.timeSelection || 'var_sector_online_month' //this.timeOptions[this.timeOptions.length-1].value
      let currentIndex = this.data.data.findIndex((m)=>m.id === timeSelection)
      if(currentIndex === -1) return
      
      let currentData = JSON.parse(JSON.stringify(this.data.data[currentIndex].data || [])) 
      currentData.sort((a,b)=>b.value-a.value)
      let max = currentData.reduce((max,d)=>max = Math.max(max,Math.abs(d.value)),0)
      // guarrete... par que quepa el numero de la barra mas larga...
      if(this.isMobile) max = max*2.3
      else max = max*1.3
      currentData.forEach((d,i)=>{
        d.width = Math.abs(100*d.value/max)/2
        d.sign = Math.sign(d.value)
        d.rank = i+1
      })
      
      // let selIndex = currentData.findIndex((d)=>d.id===this.sector)
      // let min = Math.max(0,selIndex-5)
      // currentData = currentData.slice(min,min+10)
      
      if(this.compareData){
        let currentData2 = this.compareData.data[currentIndex].data || []
        // currentData2.sort((a,b)=>b.value-a.value)
        // let max = currentData.reduce((max,d)=>max = Math.max(max,d.value),0)
        // currentData2.forEach((d)=>d.width = d.value)
        currentData2.forEach((d,i)=>{
          d.width = Math.abs(100*d.value/max)/2
          d.sign = Math.sign(d.value)
          d.rank = i+1
        })
        
        return currentData.map((d,i)=>({...d,comparedDatum:currentData2.find((dd)=>d.id===dd.id)}))
      } else {
        return currentData
      }
    },
    legendItems () {
      return [
        // {
        //   label:'Ventas Digital',
        //   class: 'primary'
        // },
        // {
        //   label:'Ventas Físicas',
        //   class: 'secondary'
        // }
      ]
    },
    timeOptions () {
      //BASURA DUPLICADA
      const timeScaleMonthOptions = [{
        value: 'var_sector_online_month',
        label: 'el último mes'
      },
      {
        value: 'var_sector_online_3_months',
        label: 'los últimos 3 meses'
      },
      {
        value: 'var_sector_online_6_months',
        label: 'los últimos 6 meses'
      }]
      if(!this.data) return null
      // return this.data.data.map((d)=>{
      //   return {
      //     value: d.id,
      //     label: timeScaleMonthOptions.find((d)=>d.value===d.id).label
      //     // data: d.data
      //   }
      // })
      return timeScaleMonthOptions.filter((d)=>this.data.data.find((dd)=>dd.id===d.value))
    }
    // barsData(){
    //   return this.data.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
    // },
    // barsData2(){
    //   return this.compareData && this.compareData.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
    // }
  },
  methods: {
    drawChart(){
      // let barsData = this.data.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
      // let barsData = this.barsData
      // let barsData2 = this.barsData2
      
      // let height = this.$refs.root.clientHeight
      // let width = this.$refs.root.clientWidth
      // let margin= {left: 20, top: 20, right: 15, bottom: 50}
      // let contentWidth = width - margin.left - margin.right
      // let contentHeight = height - margin.top - margin.bottom

      // this.xScale
    },
    updateTopItem(){
      let selIndex = this.currentRanking.findIndex((d)=>d.id===this.currentSector)
      let min = Math.min(this.currentRanking.length-this.numItems,Math.max(0,selIndex-(this.numItems/2-1)))
      this.topItemIndex = min
    },
    scrollToTopItem(){
      let ref = this.$refs.items[this.topItemIndex]
      if(!ref) return
      if(Math.abs(+this.$refs.listContent.style.top.replace('px','')+ref.offsetTop)>(this.itemHeight+1)){
        this.$refs.listContent.style.top = -ref.offsetTop+'px'
      }
    },
    scrollNext(){
      this.topItemIndex = Math.min(this.currentRanking.length-this.numItems,this.topItemIndex+5)
      // this.scrollToTopItem()
    },
    scrollPrev(){
      this.topItemIndex = Math.max(0,this.topItemIndex-5)
      // this.scrollToTopItem()
    }
  },
  watch:{
    currentRanking(){
      this.updateTopItem()
    },
    currentSector(){
      this.updateTopItem()
    },    
    topItemIndex () {
      this.$nextTick(()=>{
        this.scrollToTopItem()
      })
    }
  //   selection () {
  //     this.$emit('changeSelection',this.selection)
  //   }
  }
}
</script>

<style lang="stylus" scoped>
$bar-height = vh(9px)
$compared-bar-height = vh(3px)
.digital-rank-chart
  display: flex;
  flex-direction: column;
  user-select none
  // flex: 4 0 auto;
  flex 0 0 80%
  font-family: Lato
  >>>.chart-content
    display flex
    flex-direction column
  .root
    position relative
    flex: 1 1 auto;
    .mobile &
      height 100%
      margin: 20px 0;
    .zero-line-wrapper
      width: calc(60% - 5px);
      left: calc(40% + 5px);
      position absolute
      top 0
      height 100%
      pointer-events none
      .mobile &
        width: calc(75% - 5px);
        left: calc(25% + 5px);
      .zero-line
        width 1px
        height 100%
        position absolute
        left 50%
        background #888
    .list-container
      height 100%
      overflow hidden
      position relative
      cursor grab
      .mobile &
        height vh(220px);
      .list-content
        position absolute
        width 100%
        transition top .4s ease-in-out
      .scroll-btn
        width 100%
        background rgba(250,250,250,0.7)
        height 3vh
        position absolute
        .icon
          background-image url('~@/assets/icons/arrow-blue.svg')
          background-size contain
          background-repeat: no-repeat;
          background-position: center center;
          height vw(20px)
          width vw(12px)
          margin auto
        &.scroll-btn-top
          top 0
          .icon
            transform rotate(180deg)
        &.scroll-btn-bottom
          bottom 0
      .item-wrapper
        display flex
        align-items: center;
        .rank
          flex 0 0 20px
          padding-left 4px
          m-font-size(10,10)
        .item
          flex 1 1 auto
          // transform translate(50%,0)
          display flex
          align-items: center;  
          position relative
          .label
            text-transform uppercase
            white-space nowrap
            m-font-size(8,10)
            font-family 'Lato'
            font-weight bold
            margin: 0px 2px;
            padding-left 3px
            flex 0 0 40%
            overflow: hidden;
            text-overflow ellipsis
            .desktop &
              m-font-size(10,12)
              margin: 2px 2px;
            .mobile &
              flex 0 0 25%
              
          .rows
            flex 0 0 60%
            display flex
            flex-direction column
            transform translate(50%,0)
            .mobile &
              flex 0 0 75%
            .bar-and-value
              display flex
              // position absolute
              width 100%
              // left 50%
              transform: translate(0px,0);
              top 0
              align-items center
              .bar
                height $bar-height
                background $bs-blue
                border-radius 2px
              .value
                m-font-size(10,10)
                font-weight bold
                margin 0 4px
                // position: absolute;
                // right: 100%;
                display: flex;
                .compared-val
                  color $compare-color
                .separator
                  margin 0 2px
            .compared-bar
              height $bar-height
              background $compare-color
              // position absolute
              top $bar-height
              border-radius 2px
              margin-top 1px
              height $compared-bar-height
            
              
          &.negative
            .bar-and-value,.compared-bar
              transform: translate(-100%,0);
              flex-direction: row-reverse;
              // .value
              //   left 100%
            // .label
            //   transform: translate(-100%,0);
            //   text-align: right;
            //   margin: 2px -2px;
                        
          &.focussed
            // background #fa0
            &:before
              content ''
              position absolute
              left -20px
              width 100%
              height 3vh
              background $bs-blue
              opacity 0.2
            // .bar-and-value
            //   .bar
            //     background $bs-blue
                
  .month-selector
    display: flex
    width 80%
    margin vw(5px) auto
    flex 0 0 40px
    .month-button
      flex: 1 1 auto
      text-align: center
      font-family 'Lato'
      text-transform uppercase
      background #f8f8f8
      color #666
      m-font-size(10, 10)
      font-weight bold
      padding vw(8px) vw(5px)
      transition background .3s, color .3s
      margin auto vw(4px)
      cursor pointer
      border-radius 4px
      &.selected
        background: $tundora
        color #fff
</style>